<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="screenLine">
      <el-input @keyup.enter.native="handelComClick" v-model="keyword" placeholder="搜索商品"
        style="width: 240px; margin-right: 16px"></el-input>
        <el-cascader v-model="categoryId" :options="classOptions" :props="{ label: 'label', value: 'id',multiple: false,emitPath:true }"
						@change="handelComClick" ref="chooseRegionDom"></el-cascader>
      <el-select v-model="status" placeholder="状态" class="titleSelect" @change="handelComClick">
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-button type="warning" plain @click="handleResetClick">重置</el-button>
    </div>
    <div class="tableBox">
      <el-table :data="tableData" style="width: 100%" height="100%">
        <el-table-column label="线上分类" width="200">
          <template slot-scope="scope">
            {{ scope.row.onlineCategoryInfo == null ? '--' : scope.row.onlineCategoryInfo.name}}
          </template>
        </el-table-column>
        <el-table-column label="排序" width="200">
          <template slot-scope="scope">{{ scope.row.sort}}</template>
        </el-table-column>
        <el-table-column label="线上名称">
          <template slot-scope="scope">
            {{ scope.row.onlineName }}
          </template>
        </el-table-column>
        <el-table-column label="品牌">
          <template slot-scope="scope">
            {{ scope.row.brand }}
          </template>
        </el-table-column>
        <el-table-column label="规格/库存/规格状态">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.skuInfo" :key="index"> 
              <div class="column" style="margin-right: 10px;">
										<span>
										 {{ item.onlineSkuUnitName }}
										</span>
                    <span>
										 {{ item.stockCount }}
										</span>
                    <span>
										 {{ item.appShelves ==1? '上架' : '下架' }}
										</span>
                  </div>
                </div>
          </template>
        </el-table-column>
        <el-table-column label="上架状态">
          <template slot-scope="scope">
            <div v-if="scope.row.appShelves == 0">未上架</div>
            <div v-if="scope.row.appShelves == 1">已上架</div>
            <div v-if="scope.row.appShelves == -1">已下架</div>
          </template>
        </el-table-column>
        <el-table-column label="虚拟销量">
          <template slot-scope="scope">
            {{ scope.row.virtualSaleCount }}
          </template>
        </el-table-column>
        <el-table-column label="真实销量">
          <template slot-scope="scope">
            {{ scope.row.selectNewSort }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button v-if="$buttonAuthority('mall-edit')" type="text" size="small" @click="edit(scope.row.productId)">编辑</el-button>
            <el-button type="text" size="small" @click="handelStartEndClick(scope.row, -1)"
              v-if="scope.row.appShelves == 1&&$buttonAuthority('mall-down')">下架</el-button>
            <el-button type="text" size="small" @click="handelStartEndClick(scope.row, 1)"
              v-if="scope.row.appShelves == -1 || scope.row.appShelves == 0" v-show="$buttonAuthority('mall-up')">上架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <page :page="page.page" :total="page.total" @change="changePage" style="margin: 10px 0;"></page>
    </div>

  </div>
</template>

<script>
import page from "../../../components/page.vue"
export default {
  components: {
    page
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      shopId: this.$store.state.shopId,
      tableData: [], //表格数据
      keyword: '', //关键字
      categoryId: '',  //线上分类
      status: 99,  //上架状态  -1:下架 0:未上架 1:上架 99:全部 默认为0
      productType: 0, //产品类型  0:商品 1:药品
      fixedHeight: '',
      classOptions: [],//线上分类列表
      statusOptions: [{
        value: 99,
        label: '全部'
      }, {
        value: 0,
        label: '未上架'
      }, {
        value: 1,
        label: '已上架'
      }, {
        value: -1,
        label: '已下架'
      }],

    }
  },
  mounted() {
    console.log(this.$store.state.shopId, "this.$store.state.shopId");
    this.getTableData()
    this.getClassData()
    this.fixedHeight = document.documentElement.clientHeight - 106;
  },
  methods: {
    // 编辑
    edit(id) {
      this.$router.push({ path: 'goodEdit',query:{
					id:id
				} })
    },
    // 搜索
    handelComClick(val) {
      console.log(val);
      this.categoryId = val[val.length - 1];
      console.log(this.categoryId,"this.categoryId");
      this.page.page = 1;
      this.getTableData();
    },
    //重置
    handleResetClick() {
      this.page.page = 1;
      this.status = 99;
      this.keyword = '';
      this.categoryId = '';
      this.getTableData()
    },
    //上下架
    handelStartEndClick(row, status) {
      let params = {
        id: row.productId,
        status: status,
        shopId: this.shopId
      }
      let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/update/AppShelves/status', params).then((res) => {
        if (res.code == 0) {
          loading.close()
          if (status == 1) {
            this.$message({
              message: '已上架',
              type: 'success'
            });
            this.getTableData()
          } else if (status == -1) {
            this.$message({
              message: '已下架',
              type: 'error'
            });
            this.getTableData()
          }
        }
      })
    },
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        categoryId: this.categoryId,
        status: this.status,
        productType: this.productType,
        shopId: this.shopId
      }
      // let loading = this.$loading();
      this.$http.post(process.env.VUE_APP_Url_baseData + '/api/shop/online/product/list', params).then((res) => {
        if (res.code == 0) {
          // loading.close();
          this.tableData = res.data.data;
          this.page.total = res.data.count;

        }
      })
    },
    //获取类别
    getClassData() {
				this.$http.get(process.env.VUE_APP_Url_baseData + '/api/online/product/goods/category/list').then((res) => {
					if (res.code == 0) {
						console.log(res.data, "获取类别");
						this.classOptions = res.data
					}
				})
			},
    // 分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 16px 16px 65px 16px;
  height: 100%;
  box-sizing: border-box;
  position: relative;

  .screenLine {
    display: flex;

    .titleSelect {
      width: 130px;
      margin-right: 16px;
    }
  }

  .tableBox {
    padding: 16px;
    border-radius: 8px;
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 16px;
    height: calc(100% - 56px);
  }
}</style>